<template>
  <div class="home">



    <div class="autodiv" v-loading="loadshow">

      <div class="fun">
        <div>
          <el-row :gutter="20" v-if="!tableData">
            <el-col :span="24">
            <label>活动类别：</label>
              <el-select v-model="activeid" filterable placeholder="请选择">
                <el-option v-for="item in activeList" :key="item.id" :label="item.title" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-input v-model="name" placeholder="姓名"></el-input>
            </el-col>
            <el-col :span="5">
              <el-input v-model="mobile" placeholder="手机号"></el-input>
            </el-col>
            <el-col :span="5">
              <el-input v-model="idnum" placeholder="身份证号"></el-input>
            </el-col>
            <el-col :span="5" class="txcode">
              <el-input v-model="imgcode" placeholder="图形验证码"></el-input>
              <img :src="codeImg" @click="getcodeimg" style="height:30px; vertical-align: middle; cursor: pointer;" />
            </el-col>
            <el-col :span="5">
              <el-input v-model="code" placeholder="验证码">
                <el-button slot="append" @click="getcode" :disabled="canclick">{{ codebtn }}</el-button>
              </el-input>
            </el-col>

          </el-row>

          <div class="cntk can" v-if="tableData">
            <h3>青少年电子信息智能创新大赛</h3>
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="name" label="类别">
              </el-table-column>
              <el-table-column prop="date" label="分值">
              </el-table-column>
            </el-table>
            <div class="btncnt">
              <button class="bgbtn" @click="searchs('again')" v-if="tableData">重新查询</button>
            </div>

          </div>



          <button class="bgbtn" @click="searchs()" v-if="!tableData">点击查询</button>
        </div>
      </div>

      <div class="cntk" v-if="!tableData">
        <p class="bt">查询规则：</p>
        <p>1、姓名，手机号，身份证号，验证码为必填项</p>
        <p>2、建议使用谷歌、火狐、360等浏览器查询分数</p>
      </div>
    </div>


    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// @ is an alias to /src
import qs from 'qs';
import { request } from '@/network/request';

export default {
  name: 'home',
  data() {
    return {
      codebtn: '获取',
      canclick: false,
      countdown: 60,
      activeList: [],
      activeid: '2',
      name: '',
      mobile: '',
      idnum: '',
      code: '',
      imgcode: '',
      codeImg: '',
      tableData: '',
      loadshow: false
    }
  },
  methods: {
    getcodeimg() {
      request({
        url: '/results/verify',
        responseType: 'blob',
      }).then(res => {
        //console.log(res.data)
        this.codeImg = window.URL.createObjectURL(res.data)
      }).catch(err => {
        console.log(err)
      })
    },



    //获取验证码
    getcode() {
      let that = this;
      if (that.activeid == '' || that.name == '' || that.mobile == '' || that.idnum == '' || that.imgcode == '') {
        console.log(that.activeid, that.name, that.mobile, that.imgcode)
        this.$message.error("姓名、手机号、身份证号或图形验证码不能为空！");
      } else {
        let codetimer;
        request({
          url: "/results/sms",
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          data: qs.stringify({
            code: that.imgcode,
            id: that.activeid,
            mobile: that.mobile,
            name: that.name,
            cardno: that.idnum
          })
        })
          .then(res => {

            console.log(res);
            if (res.data.code == 0) {
              this.$message.error(res.data.msg);
              this.getcodeimg()
            } else {
              this.$message.success(res.data.msg);
              that.canclick = true;
              that.codebtn = that.countdown + "s";
              codetimer = setInterval(() => {
                that.countdown--;
                if (that.countdown > 0) {
                  that.codebtn = that.countdown + "s";
                } else {
                  clearInterval(codetimer);
                  that.countdown = 60;
                  that.codebtn = "重新发送";
                  that.canclick = false;
                }
              }, 1000);
            }
          })
          .catch(err => {
            console.log(err);
          });

      }



    },



    searchs(val) {
      console.log(val)
      if (val) {
        this.tableData = ''
      } else {
        if (this.activeid == '' || this.name == '' || this.mobile == '' || this.code == '' || this.idnum == '') {
          this.$message.error("姓名、手机号、身份证号或验证码不能为空！");
        } else {
          this.loadshow = true
          request({
            url: '/results/info',
            method: 'post',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify({
              code: this.code,
              id: this.activeid,
              mobile: this.mobile,
              name: this.name,
              cardno: this.idnum
            })
          }).then(res => {
            if (res.data.code == 0) {
              this.$message.error(res.data.msg);
              this.getcodeimg()
            } else {
              //this.tableData=res.data.data
              const entries = Object.entries(res.data.data)
              let tablearr = []
              for (const [name, date] of entries) {
                tablearr.push({ name: name, date: date })
              }
              this.tableData = tablearr
              console.log(this.tableData)
            }

            this.loadshow = false
          }).catch(err => {
            console.log(err)
          })
        }
      }


    }
  },


  created() {
    request({
      url: '/results/getlist'
    }).then(res => {
      //console.log(res)
      this.activeList = res.data.data
      this.getcodeimg()
    }).catch(err => {
      console.log(err)
    })
  },
}
</script>


<style scoped>
.el-input {
  width: 100%;
}
.el-select {
  width: 500px;
  margin-bottom: 30px;
  max-width: 100%;
}
.txcode {
  position: relative;
}

.txcode img {
  position: absolute;
  top: 5px;
  right: 15px;
}

h3 {
  color: #000;
  margin: 0;
  text-align: center;
  line-height: 70px;
  height: 70px;
}
</style>
